import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Link } from 'gatsby'

import Users from '../../../assets/users.svg'
import Email from '../../../assets/email.svg'
import logo from '../../../assets/felog.png'
import './index.scss'

export const Bio = () => (
  <StaticQuery
    query={bioQuery}
    render={data => {
      const { email, introduction, siteUrl } = data.site.siteMetadata

      return (
        <div className="bio">
          <div className="author">
            <div className="author-description">
              <Link to={`/`} className="link">
                <img
                  className="author-image"
                  src={logo}
                  style={{
                    width: '72px',
                    height: '79px',
                  }}
                />
              </Link>
              <div className="author-name">
                <div>
                  <a className="author-name-content">
                    <div>
                      <div style={{ float: 'left' }}>
                        <Email /> {email}
                      </div>
                    </div>
                  </a>
                </div>
                <div className="author-introduction">{introduction}</div>
              </div>
            </div>
          </div>
        </div>
      )
    }}
  />
)

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile.png/" }) {
      childImageSharp {
        fixed(width: 72, height: 82) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        email
        introduction
        siteUrl
      }
    }
  }
`

export default Bio
